import type { StateCreator } from 'zustand';
import type { OnboardingStatus } from '../customer/customer.types';

export enum DocVStatus {
  PENDING = 'PENDING', // used in authorized used flow
  WAITING = 'WAITING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  MANUAL_REVIEW = 'MANUAL_REVIEW',
  NONE = 'NONE',
}

export interface UboCustomerDetails {
  firstName: string;
  lastName: string;
  onboardingStatus: OnboardingStatus;
  passwordSet: boolean;
  profile: string;
  bank: string;
  customerId: string;
  country?: string;
}

export interface BusinessDetails {
  name: string;
  type: string;
}

export interface UboData {
  secondaryCustomerDetails: UboCustomerDetails;
  primaryCustomerDetails: UboCustomerDetails;
  businessDetails: BusinessDetails;
  mfaDestination: string;
}

export interface UboDocVData {
  url?: string;
  qrCode?: string;
  status: DocVStatus;
}

export type UboSlice = {
  uboData: UboData | null;
  secondaryCustomerId: string | null;
  phoneStateToken: string | null;
  isUsFlow: boolean;
  docVData: UboDocVData | null;
  uboToken: string | null;
  setUboData: (data: UboData) => void;
  setUboPhoneStateToken: (phoneToken: string) => void;
  setIsUsFlow: (isUsFlow: boolean) => void;
  setDocVData: (data: UboDocVData) => void;
  setUboToken: (token: string) => void;
  clearDocVData: () => void;
  setSecondaryCustomerId: (secondaryCustomerId: string) => void;
};

export const createUboSlice: StateCreator<UboSlice> = (set) => ({
  uboData: null,
  phoneStateToken: null,
  isUsFlow: false,
  docVData: null,
  uboToken: null,
  secondaryCustomerId: null,
  setUboData: (data) => set({ uboData: data }),
  setSecondaryCustomerId: (secondaryCustomerId) => set({ secondaryCustomerId }),
  setUboPhoneStateToken: (phoneStateToken) => set({ phoneStateToken }),
  setUboToken: (uboToken) => set({ uboToken }),
  setIsUsFlow: (isUsFlow) => set({ isUsFlow }),
  setDocVData: (docVData) =>
    set((state) => ({
      docVData: state.docVData ? { ...state.docVData, ...docVData } : docVData,
    })),
  clearDocVData: () => set({ docVData: null }),
});
